import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Input from 'components/form/Input';
import Select from 'components/form/Select';
import Button from 'components/common/Button';

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 16,
    '& .select': {
      marginBottom: 0
    }
  },
  input: {
    marginBottom: 16
  },
  action: {
    display: 'flex',
    alignItems: 'center',
  }
}));

const ModuleForm = ({ module, onSubmit, onCancel, onDelete }) => {
  const classes = useStyles();
  const [value, setValue] = useState();
  const [approach, setApproach] = useState({});

  useEffect(() => {
    setValue(module?.name || '');
    setApproach(module?.approach || '');
  }, [module]);

  return (
    <div className={classes.root}>
      <div className={classes.input}>
        <Select
          isMulti={false}
          transformValue
          placeholder="Select approach"
          value={approach}
          options={[
            { label: 'Top down', value: 'top-down' },
            { label: 'Bottom up', value: 'bottom-up' },
          ]}
          onChange={(e) => setApproach(e)}
        />
      </div>
      <div className={classes.input}>
        <Input
          disableMargin
          placeholder="Module name"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
      <div className={classes.action}>
        { module?.id && <Button onClick={onDelete} color="secondary">Delete</Button>}
        <Box marginLeft="auto">
          <Button onClick={onCancel}>Cancel</Button>
          <Button
            disabled={!value || !approach}
            variant="contained"
            color="primary"
            onClick={() => onSubmit(value, approach)}
          >
            Save
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default ModuleForm;
